import Vue from 'vue'
import Router from 'vue-router'
import login from "../view/login/login";
import index from "../view/index/index";
import orgmanagement from "../view/operationManagement/orgManagement/index";
import usemanagement from "../view/operationManagement/useManagement/index";
import refereemanagement from "../view/vipManagement/referee/list";
import personmanagement from "../view/vipManagement/person/list";
import activity from "../view/activity/list";
import activitybooking from "../view/activity/yylist";
import activitycreateedit from "../view/activity/create";
import teammanagement from "../view/vipManagement/team/list";
import teammanagementdetail from "../view/vipManagement/team/detail";
import {MessageBox} from "element-ui";


Vue.use(Router)
const myrouter= new Router({
  base:process.env.NODE_ENV === 'production'?'':'tfweb',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '杭州市田径协会',
      component: index,
      children:[
        {
          path: '/',
          redirect: '/activity'
        },
        {
            path: '/orgmanagement',
            name: '组织管理',
            component: orgmanagement,
        },
        {
          path: '/usemanagement',
          name: '用户管理',
          component: usemanagement,
        },
        {
          path: '/referee',
          name: '裁判员库',
          component: refereemanagement,
        },
        {
          path: '/person',
          name: '个人会员',
          component: personmanagement,
        },
        {
          path: '/activity',
          name: '活动中心',
          component: activity,
        },
        {
          path: '/activity/booking/list/:id/:title',
          name: '预约记录',
          component: activitybooking,
        },
        {
          path: '/activity/createEdit/:id?',
          name: '活动赛事',
          component: activitycreateedit,
        },
        {
          path: '/teammanagement',
          name: '团队管理',
          component: teammanagement,
        },
        {
          path: '/teammanagement/detail/:id',
          name: '团队详情',
          component: teammanagementdetail,
        }
        // {
        //   path: '/',
        //   name: '首页',
        //   component: indexnav,
        //   children:[
        //     {
        //       path: '/',
        //       name: '首页',
        //       component: homepage,
        //     }, {
        //       path: '/planGenerate',
        //       name: '应急预案助手',
        //       component: planGenerate,
        //     },
        //
        //   ]
        // },
        // {
        //   path: '/manage/documentreview',
        //   name: '文档审核',
        //   component: documentreview
        // },
        // {
        //   path: '/manage/documentdetail/:id',
        //   name: '文档详情',
        //   component: documentdetail
        // },
        // {
        //   path: '/manage/documentUpload',
        //   name: '上传文档',
        //   component: documentUpload
        // },{
        //   path: '/AILibrary/list',
        //   name: 'AI知识库',
        //   component: AILibrary
        // },{
        //   path: '/AILibrary/list/detail/:id',
        //   name: 'AI知识库详情',
        //   component: AILibrarydetail
        // },{
        //   path: '/AILibrary/list/create/:id?',
        //   name: '添加/编辑AI知识',
        //   component: AILibrarycreate
        // },{
        //   path: '/consultation/list/:id?',
        //   name: '标讯列表',
        //   component:()=>import('../view/consultation/list/consultationList.vue')
        // }
      ]
    },
    {
      path: '/login',
      name: '登录',
      component: login
    }
  ]
})
myrouter.beforeEach((to, from, next) => {
  document.getElementsByTagName('title')[0].innerText=to.name
  let tokenName='_$_zzb-access-token'
  if(!localStorage.getItem(tokenName)&&to.path!='/login'){
    MessageBox.alert('未登录，请先登陆！', '警告', {
      confirmButtonText: '确定',
      callback: action => {
        next({
          // path: '/login?url='+encodeURIComponent(location.href)
          path: '/login'
        })
      }
    })
  }else{
    next()
  }
  next()
})
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
export default myrouter



// WEBPACK FOOTER //
// ./src/router/index.js